import { render, staticRenderFns } from "./knowledge-base-action-output.vue?vue&type=template&id=1253c786&scoped=true"
import script from "./knowledge-base-action-output.vue?vue&type=script&lang=js"
export * from "./knowledge-base-action-output.vue?vue&type=script&lang=js"
import style0 from "./knowledge-base-action-output.vue?vue&type=style&index=0&id=1253c786&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1253c786",
  null
  
)

export default component.exports